import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './StudentEditScreen';
import StudentEdit from './StudentEditScreen';
import { toast } from 'react-toastify';
import { StoreState } from 'src/store/reducers';
import { getStudent, deleteFileStudent, getFiles, createFilesStudent } from 'src/store/actions/student-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        student: state.students.current,
        inProgress: state.students.inProgress,
        files: state.students.currentFiles,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getStudent(id)),
        getFiles: (id) => dispatch(getFiles(id)),
        addFiles: (id, requestType: string, files) =>
            dispatch(
                createFilesStudent(
                    id,
                    requestType,
                    files,
                    () => toast.success('File added successfully'),
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
        removeFile: (id) => dispatch(deleteFileStudent(id, 'some')),
    };
}

const StudentEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(StudentEdit);

export default StudentEditScreen;
